import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import * as moment from 'moment';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  msgError: string = '';

  currentDate: string = moment().format('YYYY-MM-DD');
  datePickerFrom: QRDatePicker = { calendarWidth: 224 };
  datePickerTo: QRDatePicker = { calendarWidth: 224 };

  dialogEvent: DialogEvent = {
    isButtonActionDisabled: false,
    value: { dateFrom: undefined, dateTo: undefined },
  };

  ngOnInit(): void {
    this.setDatePickers();
  }

  setDatePickers(): void {
    const dateOneMonthBefore: string = moment()
      .subtract(1, 'month')
      .format('YYYY-MM-DD');
    this.datePickerFrom = { ...this.datePickerFrom, date: dateOneMonthBefore };
    this.datePickerTo = {
      ...this.datePickerTo,
      date: this.currentDate,
      maxDate: this.currentDate,
    };
    this.dialogEvent = {
      ...this.dialogEvent,
      value: { dateFrom: dateOneMonthBefore, dateTo: this.currentDate },
    };
    this.dialogChange.emit(this.dialogEvent);
  }

  datepickerFromChange(e: string): void {
    this.dialogEvent = {
      ...this.dialogEvent,
      value: {
        ...this.dialogEvent.value,
        dateFrom: e,
      },
    };
    this.validateDates();
  }

  datepickerToChange(e: string): void {
    this.dialogEvent = {
      ...this.dialogEvent,
      value: {
        ...this.dialogEvent.value,
        dateTo: e,
      },
    };
    this.validateDates();
  }

  validateDates(): void {
    const dateFrom = moment(this.dialogEvent.value.dateFrom);
    const dateTo = moment(this.dialogEvent.value.dateTo);
    if (dateTo.isAfter(this.currentDate)) {
      this.dialogEvent = { ...this.dialogEvent, isButtonActionDisabled: true };
      this.msgError =
        'La fecha final no puede ser posterior a la fecha actual.';
    } else if (dateFrom.isAfter(dateTo)) {
      this.dialogEvent = { ...this.dialogEvent, isButtonActionDisabled: true };
      this.msgError =
        'La fecha de inicio no puede ser posterior a la fecha final.';
    } else {
      this.dialogEvent = { ...this.dialogEvent, isButtonActionDisabled: false };
      this.msgError = '';
    }
    this.dialogChange.emit(this.dialogEvent);
  }
}
